const MyStory = () => {
    return (
        <div>
            <p>This is My Story page</p>
        </div>
    )
}

export default MyStory